import React from "react";

import productService from "../services/productService";

import { showProcess, hideProcess, UserSession, getFileServer } from "../utils/util";
import { Galleria } from "primereact/galleria";
import Banner001 from "../img/Banner001.png";

import { useParams } from "react-router-dom";
import { InputNumber } from "primereact/inputnumber";
import shoppingCartService from "../services/shoppingCartService";
import userService from "../services/userService";
import { Checkbox } from "primereact/checkbox";
import { Paginator } from "primereact/paginator";
import saleOrderService from "../services/saleOrderService";
import { Timeline } from "primereact/timeline";

function withParams() {
    return (props) => <SaleOrderConclude {...props} params={useParams()} />;
}

class SaleOrderConclude extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            first: 0,
            rows: 10,
            totalRecords: 0,
            saleOrders: [],
            fileServer: getFileServer(),
        };
    }

    async componentDidMount() {
        try {
            await showProcess();

            var response = await saleOrderService.getById(this.props.params.id);

            this.setState({ saleOrder: response.data });
        } catch (err) {
            if (err.response) {
                console.log("status", err.response.status);
                console.log("headers", err.response.headers);
                console.log("data", err.response.data); // <- aqui normalmente vem a dica do que faltou
            } else {
                console.log("message", err.message);
            }
        }

        hideProcess();
    }

    formatarTelefone(telefone) {
        telefone = telefone.replace(/\D/g, "");

        // Verifica se tem DDD
        if (telefone.length <= 10) {
            // Formato: (XX) XXXX-XXXX
            return telefone.replace(/(\d{2})(\d{4})(\d{0,4})/, "($1) $2-$3");
        } else {
            // Formato: (XX) XXXXX-XXXX
            return telefone.replace(/(\d{2})(\d{5})(\d{0,4})/, "($1) $2-$3");
        }
    }

    render() {
        if (UserSession === null || UserSession === undefined || UserSession === "") {
            window.location.href = "/login";
            return;
        }
        return (
            <div
                style={{
                    padding: window.innerWidth < 768 ? "15px" : "40px",
                    overflowX: "hidden",
                    boxSizing: "border-box",
                    width: "100%",
                }}
            >
                <div>
                    {this.state.saleOrder && (
                        <>
                            <div
                                style={{
                                    textAlign: window.innerWidth < 768 ? "center" : "left",
                                    marginBottom: window.innerWidth < 768 ? "30px" : "50px",
                                }}
                            >
                                <span
                                    style={{
                                        fontSize: window.innerWidth < 768 ? "1.4em" : "36px",
                                        color: "var(--unnamed-color-411172)",
                                        fontWeight: "bold",
                                        display: "block",
                                        marginBottom: "15px",
                                    }}
                                >
                                    Obrigado pela sua compra, {UserSession.name}.
                                </span>
                                <span
                                    style={{
                                        fontSize: window.innerWidth < 768 ? "1em" : "22px",
                                        color: "var(--unnamed-color-411172)",
                                        display: "block",
                                        marginBottom: "8px",
                                        lineHeight: "1.4em",
                                    }}
                                >
                                    Obrigado por comprar conosco. Estamos processando a sua compra e
                                    avisaremos assim que estiver pronto.
                                </span>
                                <span
                                    style={{
                                        fontSize: window.innerWidth < 768 ? "1em" : "22px",
                                        color: "var(--unnamed-color-411172)",
                                        display: "block",
                                        lineHeight: "1.4em",
                                    }}
                                >
                                    Você vai receber as atualizações do seu pedido no email{" "}
                                    {UserSession.email}.
                                </span>
                            </div>

                            <table
                                style={{
                                    marginTop: "40px",
                                    width: "100%",
                                    textAlign: "center",
                                    borderCollapse: "collapse",
                                }}
                            >
                                <tr>
                                    <td style={{ width: "33%" }}>
                                        <span
                                            style={{
                                                fontSize: "22px",
                                                color: "var(--unnamed-color-411172)",
                                            }}
                                        >
                                            Pedido#
                                        </span>
                                    </td>
                                    <td style={{ width: "33%" }}>
                                        <span
                                            style={{
                                                fontSize: "22px",
                                                color: "var(--unnamed-color-411172)",
                                            }}
                                        >
                                            Valor do Pedido
                                        </span>
                                    </td>
                                    <td style={{ width: "33%" }}>
                                        <span
                                            style={{
                                                fontSize: "22px",
                                                color: "var(--unnamed-color-411172)",
                                            }}
                                        >
                                            Ítens do Pedido
                                        </span>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <span
                                            style={{
                                                fontSize: "22px",
                                                color: "var(--unnamed-color-411172)",
                                                fontWeight: "bold",
                                            }}
                                        >
                                            {this.state.saleOrder.id}
                                        </span>
                                    </td>
                                    <td>
                                        <span
                                            style={{
                                                fontSize: "22px",
                                                color: "var(--unnamed-color-411172)",
                                                fontWeight: "bold",
                                            }}
                                        >
                                            R$
                                            {this.state.saleOrder.amount.toLocaleString("pt-BR", {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                            })}
                                        </span>
                                    </td>
                                    <td>
                                        <span
                                            style={{
                                                fontSize: "22px",
                                                color: "var(--unnamed-color-411172)",
                                                fontWeight: "bold",
                                            }}
                                        >
                                            {this.state.saleOrder.lines.length}
                                        </span>
                                    </td>
                                </tr>
                            </table>

                            {/* Tabela de produtos */}
                            <table
                                style={{
                                    marginTop: "50px",
                                    width: "100%",
                                    borderCollapse: "collapse",
                                }}
                            >
                                {this.state.saleOrder.lines.map((line, index) => (
                                    <tr
                                        key={index}
                                        style={{
                                            display:
                                                window.innerWidth < 768 ? "block" : "table-row",
                                            marginBottom: window.innerWidth < 768 ? "30px" : "0",
                                            borderBottom:
                                                window.innerWidth < 768 ? "1px solid #eee" : "none",
                                        }}
                                    >
                                        <td
                                            style={{
                                                verticalAlign: "top",
                                                width: window.innerWidth < 768 ? "100%" : "300px",
                                                textAlign:
                                                    window.innerWidth < 768 ? "center" : "left",
                                                display:
                                                    window.innerWidth < 768
                                                        ? "block"
                                                        : "table-cell",
                                            }}
                                        >
                                            <img
                                                src={`${this.state.fileServer}/cards/${line.product.id}.png`}
                                                alt="Gamers Fans"
                                                style={{
                                                    width:
                                                        window.innerWidth < 768 ? "100%" : "308px",
                                                    height:
                                                        window.innerWidth < 768 ? "auto" : "180px",
                                                    maxWidth: "100%",
                                                    borderRadius: "8px",
                                                }}
                                            />
                                        </td>
                                        <td
                                            style={{
                                                verticalAlign: "top",
                                                paddingLeft: window.innerWidth < 768 ? "0" : "25px",
                                                textAlign:
                                                    window.innerWidth < 768 ? "center" : "left",
                                                display:
                                                    window.innerWidth < 768
                                                        ? "block"
                                                        : "table-cell",
                                                paddingTop: window.innerWidth < 768 ? "10px" : "0",
                                            }}
                                        >
                                            <span
                                                style={{
                                                    fontSize:
                                                        window.innerWidth < 768 ? "1.3em" : "36px",
                                                    color: "var(--unnamed-color-411172)",
                                                    fontWeight: "bold",
                                                    display: "block",
                                                    marginBottom: "10px",
                                                }}
                                            >
                                                {line.product.displayName}
                                            </span>
                                            <span
                                                style={{
                                                    fontSize:
                                                        window.innerWidth < 768 ? "1em" : "22px",
                                                    color: "var(--unnamed-color-411172)",
                                                    display: "block",
                                                    marginBottom: "8px",
                                                }}
                                            >
                                                R$
                                                {line.amount.toLocaleString("pt-BR", {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2,
                                                })}
                                            </span>
                                            <span
                                                style={{
                                                    fontSize:
                                                        window.innerWidth < 768 ? "0.9em" : "22px",
                                                    color: "var(--unnamed-color-411172)",
                                                    display: "block",
                                                    lineHeight: "1.4em",
                                                }}
                                            >
                                                Seu gift-card será enviado para {UserSession.name}
                                                <br />
                                                para o e-mail {UserSession.email}
                                            </span>
                                        </td>
                                    </tr>
                                ))}
                            </table>
                        </>
                    )}
                </div>
            </div>
        );
    }
}

export default withParams();
